import ApiHelper from "../../utils/apiHelper";
import { selectApiBaseUrl } from "./globalModule";
// helpers
import { getFormattedRouteAddress } from "../../utils/helpers/getFormattedRouteAddress";
import { hasValidLatLng } from "../../utils/helpers/getFormattedRouteAddress";

export const googleSearchActionTypes = {
  TOGGLE_GEOCODING_DEPARTURE_LOADER: "TOGGLE_GEOCODING_DEPARTURE_LOADER",
  TOGGLE_GEOCODING_DESTINATION_LOADER: "TOGGLE_GEOCODING_DESTINATION_LOADER",
  LOAD_GEOCODING_DEPARTURE: "LOAD_GEOCODING_DEPARTURE",
  LOAD_GEOCODING_DESTINATION: "LOAD_GEOCODING_DESTINATION",
  SET_IS_VALID_DEPARTURE: "SET_IS_VALID_DEPARTURE",
  SET_IS_VALID_DESTINATION: "SET_IS_VALID_DESTINATION",
  RESET_GOOGLE_GEOCODING_FROM_TO_STATE: "RESET_GOOGLE_GEOCODING_FROM_TO_STATE"
};

let initialState = {
  isLoadingGeocodingDeparture: false,
  isLoadingGeocodingDestination: false,
  geocodingDeparture: null,
  geocodingDestination: null,
  isValidDepartureAddress: false,
  isValidDestinationAddress: false
};

const googleSearchModule = (state = initialState, action: any) => {
  switch (action.type) {
    case googleSearchActionTypes.TOGGLE_GEOCODING_DEPARTURE_LOADER: {
      return {
        ...state,
        isLoadingGeocodingDeparture: action.isLoadingGeocodingDeparture
      };
    }
    case googleSearchActionTypes.TOGGLE_GEOCODING_DESTINATION_LOADER: {
      return {
        ...state,
        isLoadingGeocodingDestination: action.isLoadingGeocodingDestination
      };
    }
    case googleSearchActionTypes.LOAD_GEOCODING_DEPARTURE: {
      const shouldUseLatLngValidation = action.useLocationForValidation;
      const hasLatLng = hasValidLatLng(action.geocodingDeparture);

      return {
        ...state,
        geocodingDeparture: getFormattedRouteAddress(action.geocodingDeparture, shouldUseLatLngValidation),
        isValidDepartureAddress: shouldUseLatLngValidation ? hasLatLng : !!action.geocodingDeparture?.street_number
      };
    }
    case googleSearchActionTypes.LOAD_GEOCODING_DESTINATION: {
      const shouldUseLatLngValidation = action.useLocationForValidation;
      const hasLatLng = hasValidLatLng(action.geocodingDestination);

      return {
        ...state,
        geocodingDestination: getFormattedRouteAddress(action.geocodingDestination, shouldUseLatLngValidation),
        isValidDestinationAddress: shouldUseLatLngValidation ? hasLatLng : !!action.geocodingDestination?.street_number
      };
    }
    case googleSearchActionTypes.SET_IS_VALID_DEPARTURE: {
      return {
        ...state,
        isValidDepartureAddress: action.isValidDepartureAddress
      };
    }
    case googleSearchActionTypes.SET_IS_VALID_DESTINATION: {
      return {
        ...state,
        isValidDestinationAddress: action.isValidDestinationAddress
      };
    }
    case googleSearchActionTypes.RESET_GOOGLE_GEOCODING_FROM_TO_STATE: {
      return {
        ...state,
        geocodingDeparture: null,
        isValidDepartureAddress: false,
        geocodingDestination: null,
        isValidDestinationAddress: false
      };
    }

    default:
      return state;
  }
};

export default googleSearchModule;

export const googleSearchCreators = {
  getGoogleGeocoding:
    (placeId: string, route: string, useLocationForValidation?: boolean) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());

      const isDepartureRoute = route === "departure";
      // handle / turn on geocoding loader
      if (isDepartureRoute) {
        dispatch({
          type: googleSearchActionTypes.TOGGLE_GEOCODING_DEPARTURE_LOADER,
          isLoadingGeocodingDeparture: true
        });
      } else {
        dispatch({
          type: googleSearchActionTypes.TOGGLE_GEOCODING_DESTINATION_LOADER,
          isLoadingGeocodingDestination: true
        });
      }

      try {
        const response = await ApiHelper.get(`${apiUrl}/geocoding/address/${placeId}`);
        if (isDepartureRoute) {
          dispatch({
            type: googleSearchActionTypes.LOAD_GEOCODING_DEPARTURE,
            geocodingDeparture: response.data,
            useLocationForValidation
          });
        } else {
          dispatch({
            type: googleSearchActionTypes.LOAD_GEOCODING_DESTINATION,
            geocodingDestination: response.data,
            useLocationForValidation
          });
        }
      } catch (e) {
        dispatch(googleSearchCreators.setIsValidGoogleFromToAddress(route, false));
      } finally {
        // handle / turn off geocoding loader
        if (isDepartureRoute) {
          dispatch({
            type: googleSearchActionTypes.TOGGLE_GEOCODING_DEPARTURE_LOADER,
            isLoadingGeocodingDeparture: false
          });
        } else {
          dispatch({
            type: googleSearchActionTypes.TOGGLE_GEOCODING_DESTINATION_LOADER,
            isLoadingGeocodingDestination: false
          });
        }
      }
    },
  setIsValidGoogleFromToAddress: (route: string, state: boolean) => (dispatch: any) => {
    if (route === "departure") {
      dispatch({ type: googleSearchActionTypes.SET_IS_VALID_DEPARTURE, isValidDepartureAddress: state });
    } else if ("destination") {
      dispatch({ type: googleSearchActionTypes.SET_IS_VALID_DESTINATION, isValidDestinationAddress: state });
    }
  },
  resetGoogleGeocodingFromToState: () => (dispatch: any) => {
    dispatch({ type: googleSearchActionTypes.RESET_GOOGLE_GEOCODING_FROM_TO_STATE });
  }
};
